module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-45.84953fdd.png";